import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-cup-fill text-lg" style={{ width: 18, height: 18 }} />
              </span>
              <span className="font-heading text-xl tracking-wide text-primary-700">可乐漫画</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              配可乐看漫画的快乐，来可乐漫画就对了。这里有可乐漫画配可乐、肥宅快乐套餐，追更配零食，
              周末放松摸鱼必备，快乐水组合让你一次看个够。
            </p>
            <div className="mt-5 flex gap-3">
              {["ri-wechat-fill", "ri-weibo-fill", "ri-bilibili-fill", "ri-tiktok-fill"].map((icon) => (
                <a
                  key={icon}
                  href="#contact"
                  aria-label="社交平台"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={icon} style={{ width: 16, height: 16 }} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-label text-sm font-medium text-foreground-950">快速导航</h4>
            <ul className="mt-4 space-y-3">
              <li><Link to="/list" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">追更榜单</Link></li>
              <li><Link to="/category/rexue" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">主题分类</Link></li>
              <li><Link to="/article/1" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">追更指南</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm font-medium text-foreground-950">热门分类</h4>
            <ul className="mt-4 space-y-3">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link to={`/category/${c.slug}`} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 可乐漫画 Cola Comics · 快乐水组合，快乐追更每一天
          </p>
          <div className="flex items-center gap-4">
            <Link to="/faq" className="text-xs text-foreground-500 transition-colors hover:text-primary-600">常见问题</Link>
            <Link to="/contact" className="text-xs text-foreground-500 transition-colors hover:text-primary-600">联系我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}